export default __webpack_public_path__ + "static/media/pp-business-loan-v-knockout.fd101fd3.svg";